export default "__VITE_ASSET__Cnn6LYqD__"